import React, {useMemo, useState} from 'react'
import styled from 'styled-components'
import {useTranslation} from 'i18n'
import {getAuthPrivacy} from 'utils'
import {TemplateLegalModal} from 'pages'
import {Button, CheckboxItem} from 'common/components'
import convertUnit from 'lib/unit'
import {useSelector} from 'lib/redux'

const StyledAgreementFooter = styled.div`
  margin: ${convertUnit(20)};
  margin-bottom: 0;
  gap: ${convertUnit(20)};
`

interface ModalPolicyUpdateItemProps {
  visible: boolean
  onAgree(): void
}
export default function ModalPolicyUpdateItem({
  visible,
  onAgree,
}: ModalPolicyUpdateItemProps) {
  const {translate} = useTranslation()
  const {lang} = useSelector('user') || {}
  const [checkbox, setCheckbox] = useState(false)

  const handleRenderModalLegal = useMemo(
    () => (
      <TemplateLegalModal
        src={`${getAuthPrivacy()}&lang=${lang}`}
        visible={visible}
        containerStyle={{paddingTop: convertUnit(20)}}
        showCloseButton={false}
        footer={
          <StyledAgreementFooter>
            <CheckboxItem
              isSelected={checkbox}
              description={translate('giftShop:agreementLegalUpdate')}
              fontSize="m"
              onClick={() => setCheckbox((prev) => !prev)}
            />
            <Button
              label={translate('global:iAgree')}
              disabled={!checkbox}
              onClick={onAgree}
            />
          </StyledAgreementFooter>
        }
      />
    ),
    [checkbox, lang, onAgree, translate, visible],
  )
  return handleRenderModalLegal
}
